import { Navigate, Outlet } from 'react-router';

import { useAuthStore } from '@/store/auth.store';

/**
 * Keeps signed-in users off the guest-only pages (login, register, forgot-password). Registration
 * leaves the user authenticated but businessless until its second step finishes, so only a
 * fully-onboarded user (one with a business) is redirected away — otherwise a failed business
 * creation on the register wizard's last step would bounce them to "/" before they can retry it.
 */
export function PublicRouteOutlet() {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
	const hasBusiness = useAuthStore((state) => state.businesses.length > 0);

	if (isAuthenticated && hasBusiness) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}
